export default "__VITE_ASSET__Dv4SpClk__"